import { useQuery } from '@apollo/client';
import { GET_BREADCRUMBS } from './queries';

export const useGetBreadcrumbs = (input?: string) => {
    const { data, loading, refetch, error } = useQuery(GET_BREADCRUMBS, {
        variables: {
            input
        },
        skip: !input
    });

    return ({ breadcrumbs: data?.getUserBreadcrumbs, loading, error, refetch });
};
